<kendo-upload
    [saveUrl]="uploadSaveUrl"
    [removeUrl]="uploadRemoveUrl"
    (select)="onSelect($event)"
    (remove)="onRemove()"
    [multiple]="false">
    <kendo-upload-messages select="Select image">
    </kendo-upload-messages>
</kendo-upload>